import { render, staticRenderFns } from "./AnswerItem.vue?vue&type=template&id=d7de80ca&scoped=true&"
import script from "./AnswerItem.vue?vue&type=script&lang=js&"
export * from "./AnswerItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7de80ca",
  null
  
)

export default component.exports